module.exports = __webpack_public_path__ + "static/media/caseInfoBtn.17779993.png";